import CounterpartiesAPI from "../../../api/CounterpartiesAPI";
import CounterpartyAddressAPI from "../../../api/CounterpartyAddressAPI";
import DirectoryLegalFromsAPI from "../../../api/DirectoryLegalFromsAPI";

import counterpartyBuilder from "../../../models/counterparty/counterparty.builder";
import counterpartyForContractBuilder from "../../../models/counterparty/counterparty.for.contract.builder";

import CounterpartyTypeTransformer from "../../../transformers/Counterparty/CounterpartyTypeTransformer";
import CounterpartyDirectoryLegalFromsTransformer from "../../../transformers/Counterparty/CounterpartyDirectoryLegalFromsTransformer";
import CounterpartyAddressTypeTransformer from "../../../transformers/Counterparty/CounterpartyAddressTypeTransformer";

import CounterpartyLegalPerson from "../../../models/counterparty/CounterpartyLegalPerson";
import CounterpartyNaturalPerson from "../../../models/counterparty/CounterpartyNaturalPerson";
import CounterpartySoleProprietorship from "../../../models/counterparty/CounterpartySoleProprietorship";

export default {
  async getAllCounterpartyTypes({ commit }) {
    const response = await new CounterpartiesAPI().getAllTypes();
    commit("SET_ALL_COUNTERPARTY_TYPES", CounterpartyTypeTransformer.fetchCollections(response));
  },
  async getAllCounterpartyAddressTypes({ commit }) {
    const response = await new CounterpartyAddressAPI().getAllAddressTypes();
    commit("SET_ALL_COUNTERPARTY_ADDRESS_TYPES", CounterpartyAddressTypeTransformer.fetchCollections(response));
  },
  async getAllDirectoryLegalForms({ commit }) {
    const response = await new DirectoryLegalFromsAPI().all();
    commit("SET_ALL_DIRECTORY_LEGAL_FORMS", CounterpartyDirectoryLegalFromsTransformer.fetchCollections(response));
  },
  async getAllCounterparties({ commit }) {
    const api = new CounterpartiesAPI();
    const response = await api.all();
    const counterpartyHistory = await api.getCounterpartiesHistory();
    const allcounterParties = [];
    const counterpartiesInfoForContract = [];
    for (let i = 0; i < response.length; i++) {
      const element = response[i];
      allcounterParties.push(counterpartyBuilder(element));
      counterpartiesInfoForContract.push(counterpartyForContractBuilder(element));
    }
    commit("SET_ALL_COUNTERPARTIES", allcounterParties);
    commit("SET_COUNTERPARTIES_HISTORY", counterpartyHistory);
    commit('SET_COUNTERPARTIES_FOR_CONTRACT', counterpartiesInfoForContract);
  },
  async createCounterpartyLegalPerson({ commit }, data) {
    const convertedModel = CounterpartyLegalPerson.convertToSendData(data);
    const response = await new CounterpartiesAPI().createLegalPerson(convertedModel);
    commit("ADD_COUNTERPARTY", counterpartyBuilder(response));
    commit("SET_CURRENT_COUNTERPARTY_ID", response.counterparty.idInDB);
  },
  async updateCounterpartyLegalPerson({ commit }, data) {
    const convertedModel = CounterpartyLegalPerson.convertToSendData(data);
    const response = await new CounterpartiesAPI().updateLegalPerson(data.idInDB, convertedModel);
    commit("UPDATE_COUNTERPARTY", counterpartyBuilder(response));
    commit("SET_CURRENT_COUNTERPARTY_ID", null);
    commit("SET_CURRENT_COUNTERPARTY_ID", data.idInDB);
  },

  async createCounterpartyNaturalPerson({ commit }, data) {
    const convertedModel = CounterpartyNaturalPerson.convertToSendData(data);
    const response = await new CounterpartiesAPI().createNaturalPerson(convertedModel);
    commit("ADD_COUNTERPARTY", counterpartyBuilder(response));
    commit("SET_CURRENT_COUNTERPARTY_ID", response.counterparty.idInDB);
  },
  async updateCounterpartyNaturalPerson({ commit }, data) {
    const convertedModel = CounterpartyNaturalPerson.convertToSendData(data);
    const response = await new CounterpartiesAPI().updateNaturalPerson(data.idInDB, convertedModel);
    commit("UPDATE_COUNTERPARTY", counterpartyBuilder(response));
    commit("SET_CURRENT_COUNTERPARTY_ID", null);
    commit("SET_CURRENT_COUNTERPARTY_ID", data.idInDB);
  },

  async createCounterpartySoleProprietorship({ commit }, data) {
    const convertedModel = CounterpartySoleProprietorship.convertToSendData(data);
    const response = await new CounterpartiesAPI().createSoleProprietorship(convertedModel);
    commit("ADD_COUNTERPARTY", counterpartyBuilder(response));
    commit("SET_CURRENT_COUNTERPARTY_ID", response.counterparty.idInDB);
  },
  async updateCounterpartySoleProprietorship({ commit }, data) {
    const convertedModel = CounterpartySoleProprietorship.convertToSendData(data);
    const response = await new CounterpartiesAPI().updateSoleProprietorship(data.idInDB, convertedModel);
    commit("UPDATE_COUNTERPARTY", counterpartyBuilder(response));
    commit("SET_CURRENT_COUNTERPARTY_ID", null);
    commit("SET_CURRENT_COUNTERPARTY_ID", data.idInDB);
  },

  async searhCounterparty({ commit }, query) {
    let response = await new CounterpartiesAPI().searchCounterparty(query);
    const allcounterParties = [];
    for (let i = 0; i < response.length; i++) {
      const element = response[i];
      allcounterParties.push(counterpartyBuilder(element));
    }
    if(allcounterParties.length !== 0){
      commit("SET_CURRENT_COUNTERPARTY_ID", allcounterParties[0].idInDB);
    }
    return allcounterParties;
  },

  async counterpartyImport({commit}, data) {
    return await new CounterpartiesAPI().excelImport(data);
  },
  async counterpartyVatImport({commit}, data) {
    return await new CounterpartiesAPI().excelVatImport(data);
  }
};
